document.addEventListener("alpine:init", () => {
    Alpine.data("eventPeople", (count) => ({
        selectedPerson: 0,
        totalPeople: count - 1,
        height: 0,
        contentContainer: null,
        init() {
            this.contentContainer = this.$el.querySelector(
                ".Event__People__container"
            );
            pegasus.onResizeFinished(() => {
                this.height = 0;
                this.equalHeight(".Event__People__item");
            }, true);

            this.swipe();
        },
        equalHeight(element) {
            const _this = this;
            document.querySelectorAll(element).forEach(function (el) {
                if (el.scrollHeight > _this.height) {
                    _this.height = el.scrollHeight;
                }
            });
            this.contentContainer.style.height = this.height + "px";
        },
        swipe() {
            let touchstartX = 0;
            let touchendX = 0;

            const _this = this;

            function checkDirection() {
                if (touchendX < touchstartX) {
                    // left
                    if (_this.selectedPerson < _this.totalPeople) {
                        _this.selectedPerson = _this.selectedPerson + 1;
                    }
                }
                if (touchendX > touchstartX) {
                    // right
                    if (_this.selectedPerson > 0) {
                        _this.selectedPerson = _this.selectedPerson - 1;
                    }
                }
            }

            this.contentContainer.addEventListener("touchstart", (e) => {
                touchstartX = e.changedTouches[0].screenX;
            });

            this.contentContainer.addEventListener("touchend", (e) => {
                touchendX = e.changedTouches[0].screenX;
                checkDirection();
            });
        },
    }));
});
